export default {
  qrCodeModal: 'qr-code-modal',
  addBrochureModal: 'add-brochure-modal',
  addWebAREmbedModal: 'add-web-ar-embed-modal',
  webAREmbedCodeModal: 'web-ar-embed-code-modal',
}
